<template>
  <div v-if="result" class="repair-status-item-progress">
    <div
      v-for="(status, key) in statuses"
      class="repair-status-item-progress__item"
      :class="{ 'repair-status-item-progress__item_active': status?.active }"
      :style="{ '--color-done': status?.color }"
    >
      <span class="repair-status-item-progress__check">
        <svg class="repair-status-item-progress__icon"><use xlink:href="#svg-check"></use></svg>
      </span>
      <div class="repair-status-item-progress__block">
        <p
          class="repair-status-item-progress__title"
          :style="{ '--color-title': status?.active ? '#030304' : '#5f5f67' }"
        >
          {{ status.name }}
        </p>
        <span class="repair-status-item-progress__date" v-html="status.date" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const { result } = defineProps(['result']);

const statuses = computed(() => {
  let updateColor = true;
  return result.statuses.map((el) => {
    let status = el;
    if (updateColor) {
      status = { ...status, color: result.response.color };
    }
    switch (el?.code) {
      case result.response.code:
        updateColor = false;
        status = {
          ...el,
          ...result.response,
        };
        break;
      default:
        break;
    }
    return status;
  });
});
const currentStatus = computed(() => statuses.value.filter((el) => el?.active));
</script>

<script>
export default {
  name: 'RepairStatusItemProgress',
};
</script>

<style lang="scss" scoped>
.repair-status-item-progress {
  display: grid;
  position: relative;
  @include point-md {
    grid-auto-flow: column;
  }

  &__check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: var(--color-done);
    border-radius: 50%;
    margin-right: 8px;
    @include point-md {
      margin-right: 0;
      margin-bottom: 8px;
    }
  }

  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    /*fill: #fff;*/
  }

  &__item {
    display: flex;
    align-items: center;
    position: relative;
    font-weight: 500;
    font-size: rem(12);
    line-height: 120%;
    color: var(--color-dark-grey);
    padding: 17px 0;
    @include point-md {
      flex-direction: column;
      padding: unset;
    }
    @include point-lg {
      font-size: rem(14);
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 11px;
      width: 2px;
      background-color: var(--color-done);
      z-index: -1;
      margin: 0 1px;
      @include point-md {
        top: 11px;
        width: 100%;
        height: 2px;
        left: unset;
        bottom: unset;
      }
    }

    &:first-child {
      padding-top: 0;
      @include point-md {
        align-items: flex-start;
        align-self: unset;
      }

      .repair-status-item-progress__check {
        align-self: flex-start;
      }
    }

    &:last-child {
      padding-bottom: 0;
      @include point-md {
        align-items: flex-end;
      }

      .repair-status-item-progress__check {
        align-self: flex-end;
      }
    }

    &_active ~ .repair-status-item-progress__item {
      &:before,
      .repair-status-item-progress__check {
        background-color: #f6f6f6;
      }

      .repair-status-item-progress__icon {
        fill: var(--background-black);
      }
    }
  }

  &__title {
    color: var(--color-title);
    /*color: var(--color-main);*/
    margin-bottom: 4px;
  }

  &__block {
    display: flex;
    flex-direction: column;
  }

  &__date {
    font-size: rem(12);
    @include point-md {
      font-size: rem(11);
    }
    @include point-lg {
      font-size: rem(14);
    }
  }
}
</style>
